<template>
  <div class="content dashboard">
    <loading :mask=true :size="'big'" :isWhite=true v-if="isShowLoading"/>
    <div class="content-body">
      <div class="top_layer">
        <div class="row left">
          <div class="content left-section">
            <loading :mask=true :size="'middle'" :isWhite=true v-if="portStatusLoad"/>
            <div class="col-header status-selection">{{$t('overview.portStatus')}}</div>
            <machine ref="machine"></machine>
            <div class="legend">
                <div class="link">{{$t('linkUp')}}</div>
                <div class="nolink">{{$t('linkDown')}}</div>
                <div class="icon-tick ft-14 p-b-r5-l10">{{$t('port.enabled')}}</div>
                <div class="icon-btn_close ft-14 p-b-r5-l10">{{$t('port.disabled')}}</div>
            </div>
            <div class="icon-refresh" @click="onRefresh('portstatus')"></div>
          </div>
        </div>
        <div class="row right no-s">
          <div class="content">
            <loading :mask=true :size="'middle'" :isWhite=true v-if="sysInfoLoad || firstSysInfoLoad"/>
            <div class="col-header">{{$t('menu.sysinformation')}}</div>
            <scrollbar ref="scrollbar" class="scrollbar-body">
            <div class="col-body">
              <div class="table-row">
                <div class="title">{{$t('overview.modelname')}}</div>
                <div :title="systemHostInfo.Product" class="value" v-if="systemHostInfo">{{systemHostInfo.Product}}</div>
              </div>
              <div class="table-row">
                <div class="title">{{$t('overview.ipaddress')}} </div>
                <div :title="ipAddressMag" class="value">{{ipAddressMag}}</div>
              </div>
              <div class="table-row">
                <div class="title">{{$t('overview.macaddress')}} </div>
                <div :title="sysBoard.MacAddr" class="value" v-if="sysBoard">{{sysBoard.MacAddr}}</div>
              </div>
              <div class="table-row">
                <div class="title">{{$t('overview.switchFw')}} </div>
                <div :title="fwinfo.version+'.'+fwinfo.number" class="value" v-if="fwinfo">{{fwinfo.version+'.'+fwinfo.number}}</div>
              </div>
              <div class="table-row">
                <div class="title">{{$t('overview.temperature')}} </div>
                <div :title="getTempMsg(sensorStatus)" class="value" :class="[ (sensorStatus && (sensorStatus.SwitchTemp > maxTemp || sensorStatus.SwitchTemp < minTemp)) ? 'warning-msg' : '']">{{tempMsg}}</div>
              </div>
              <div class="table-row" v-if="showFan" v-for="(item, idx) in fanData" :key="idx">
                <div class="title">{{getFanTitle(item, idx)}}</div>
                <div :title="item.val" class="value" >{{item.val}} RPM</div>
              </div>
              <div class="table-row" v-if="sensorStatus && sensorStatus.PowerInfo && sensorStatus.PowerInfo.length > 0">
                <div class="title">{{$t('overview.activePower')}} </div>
                <div :title="activePower" class="value active-power" @click="onActiveClick">{{activePower}}</div>
              </div>
            </div>
            </scrollbar>
            <div class="icon-refresh" @click="onRefresh('sysinfo')"></div>
          </div>
        </div>
      </div>
      <div class="bottom_layer no-s" v-if="systemHostInfo && (systemHostInfo.Product.includes('M408') || systemHostInfo.Product.includes('M2108') || systemHostInfo.Product.includes('M5216') || systemHostInfo.Product.includes('M2106'))">
        <div class="row left">
          <div class="content">
            <loading :mask=true :size="'middle'" :isWhite=true v-if="oneTrafficLoad"/>
            <div class="col-header chart-selection">{{getPortTrafficName}}</div>
            <div class="col-body">
              <div class="traffic-info">
                <span class="title">{{$t('overview.currentTraffic')}}</span>
                <span style="margin-left: 5px;">{{trafficInfo.one.current}} Mbps</span>
              </div>
              <!-- <div class="traffic-info">
                <span class="title">{{$t('overview.totalTraffic')}}</span>
                <span style="margin-left: 5px;">{{trafficInfo.one.total}}</span>
              </div> -->
              <ve-histogram ref="oneG" :data="chartData" :settings="chartConfig.setting" :y-axis="chartConfig.yAxis" :extend="chartConfig.extend" :grid="chartConfig.grid" :colors="chartConfig.color" width="auto" height="215px"></ve-histogram>
            </div>
            <div class="icon-refresh" @click="onRefresh((systemHostInfo.Product.includes('M5216')) ? 'twentyG5' : 'oneG')"></div>
          </div>
        </div>
        <div class="row right">
          <div class="content">
            <loading :mask=true :size="'middle'" :isWhite=true v-if="tenTrafficLoad"/>
            <div class="col-header chart-selection">{{$t('overview.tenGtraffic')}}</div>
            <div class="col-body">
              <div class="traffic-info">
                <span class="title">{{$t('overview.currentTraffic')}}</span>
                <span style="margin-left: 5px;">{{trafficInfo.ten.current}} Mbps</span>
              </div>
              <!-- <div class="traffic-info">
                <span class="title">{{$t('overview.totalTraffic')}}</span>
                <span style="margin-left: 5px;">{{trafficInfo.ten.total}}</span>
              </div> -->
              <ve-histogram ref="tenG" :data="tenGchartData" :settings="chartConfig.setting" :y-axis="chartConfig.tenyAxis" :extend="chartConfig.extend" :grid="chartConfig.grid" :colors="chartConfig.color" width="auto" height="215px"></ve-histogram>
            </div>
            <div class="icon-refresh" @click="onRefresh('tenG')"></div>
          </div>
        </div>
      </div>
      <div class="bottom_layer no-s" v-else >
        <div class="row">
          <div class="content">
            <loading :mask=true :size="'middle'" :isWhite=true v-if="tenTrafficLoad"/>
            <div class="col-header chart-selection">{{$t('overview.tenGtraffic')}}</div>
            <div class="col-body">
              <div class="traffic-info">
                <span class="title">{{$t('overview.currentTraffic')}}</span>
                <span style="margin-left: 5px;">{{trafficInfo.ten.current}} Mbps</span>
              </div>
              <!-- <div class="traffic-info">
                <span class="title">{{$t('overview.totalTraffic')}}</span>
                <span style="margin-left: 5px;">{{trafficInfo.ten.total}}</span>
              </div> -->
              <ve-histogram ref="tenG" :data="tenGchartData" :settings="chartConfig.setting" :y-axis="chartConfig.tenyAxis" :extend="chartConfig.extend" :grid="chartConfig.grid" :colors="chartConfig.color" width="auto" height="215px"></ve-histogram>
            </div>
            <div class="icon-refresh" @click="onRefresh('tenG')"></div>
          </div>
        </div>
      </div>
    </div>
    <popup-confirm name="fail-update-modal" type="w" :dialog-header="$t('warning')" :dialog-message="$t('updatefw.fwFailContent', {error_code: 500})" icon="w" :onlyOk="true" />
  </div>
</template>

<script>
import moment from 'moment'
import VeHistogram from 'v-charts/lib/histogram.common'
import echarts from 'echarts'
import FirmwareUpdate from './FirmwareUpdate'
import machine from './module/Machine'
import utility from '../util/utility'
import config from '../config'
import {
  mapState,
  mapActions,
  mapMutations
} from 'vuex'
export default {
  name: 'Dashboard',
  components: {
    VeHistogram,
    echarts,
    machine,
    FirmwareUpdate
  },
  data () {
    return {
      systemInterval: null,
      portTrafficInterval: null,
      ipInterval: null,
      portInterval: null,
      ports: [],
      cpuLoading: 0,
      chartConfig: {
        yAxis: {
          name: this.$t('mbps'),
          nameTextStyle: {
            width: 25,
            fontWeight: 'bold'
          },
          splitLine: {
            lineStyle: {
              type: 'dashed',
              color: '#8EA0F9',
              opacity: 0.5
            }
          },
          axisLabel: {
            color: '#000000',
            formatter: this.oneyAxisFormat
          },
          min: 0
        },
        tenyAxis: {
          name: this.$t('mbps'),
          nameTextStyle: {
            width: 25,
            fontWeight: 'bold'
          },
          splitLine: {
            lineStyle: {
              type: 'dashed',
              color: '#8EA0F9',
              opacity: 0.5
            }
          },
          axisLabel: {
            color: '#000000',
            formatter: this.tenyAxisFormat
          },
          min: 0
        },
        grid: {
          show: true,
          borderColor: 'none',
          right: 50,
          top: 30,
          bottom: 5
        },
        setting: {
          itemStyle: {
            normal: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1,
                [
                  {offset: 0, color: '#5AC0E5'},
                  {offset: 1, color: '#6D7AF2'}
                ]
              )
            }
          }
        },
        extend: {
          series: {
            barWidth: 25,
            cursor: 'default',
            barMinHeight: 2
          },
          xAxis: {
            name: this.$t('overview.potNo'),
            nameLocation: 'end',
            nameGap: 10,
            nameTextStyle: {
              color: '#000000',
              fontWeight: 'bold'
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: '#8EA0F9',
                type: 'solid',
                width: 2
              }
            },
            axisLabel: {
              color: '#000000'
            }
          },
          legend: {
            show: false
          },
          tooltip: {
            formatter: this.chartTooltipFormatter
          }
        }
      },
      chartData: {
        columns: ['portNum', 'Traffic'],
        rows: []
      },
      tenGchartData: {
        columns: ['portNum', 'Traffic'],
        rows: []
      },
      systemStatus: null,
      ipAddress: null,
      isShowLoading: false,
      preData: { first: [], second: [] },
      trafficData: null,
      firstSysInfoLoad: true,
      sysInfoLoad: false,
      portStatusLoad: false,
      oneTrafficLoad: false,
      tenTrafficLoad: false,
      trafficInfo: {
        'one': {'total': '0 GB', 'current': 0},
        'ten': {'total': 0, 'current': 0}
      },
      menuList: config.menu,
      fanData: [],
      showFan: false,
      fanRpm: false,
      portSpeed: []
    }
  },
  beforeDestroy () {
    clearInterval(this.systemInterval)
    clearInterval(this.portTrafficInterval)
    clearInterval(this.ipInterval)
    clearInterval(this.portInterval)
    this.systemInterval = null
    this.portTrafficInterval = null
    this.ipInterval = null
    this.portInterval = null
  },
  watch: {
    currentUser: {
      handler (value) {
        if (value && value.auth !== undefined) {
          this.showInfo()
          if (!this.systemHostInfo.Product.includes('M2108')) {
            this.getFWcondition()
              .then((result) => {
                if (result.data.result.anomaly) {
                  if (!this.$cookie.get(config.system.cookieShowFwWin) || this.$cookie.get(config.system.cookieShowFwWin) !== 'none') {
                    this.openModal('fail-update-modal')
                    this.$modal.show('fail-update-modal')
                    this.$cookie.set(config.system.cookieShowFwWin, 'none')
                  }
                }
              })
          }
        } else {
          clearInterval(this.systemInterval)
          clearInterval(this.portTrafficInterval)
          clearInterval(this.ipInterval)
          clearInterval(this.portInterval)
          this.systemInterval = null
          this.portTrafficInterval = null
          this.ipInterval = null
          this.portInterval = null
        }
      },
      immediate: true,
      deep: true
    },
    isLogin: function (value) {
      if (!value) {
        clearInterval(this.systemInterval)
        clearInterval(this.portTrafficInterval)
        clearInterval(this.ipInterval)
        clearInterval(this.portInterval)
        this.systemInterval = null
        this.portTrafficInterval = null
        this.ipInterval = null
        this.portInterval = null
      }
    },
    showFullLoading: function (value) {
      if (value) {
        clearInterval(this.systemInterval)
        clearInterval(this.portTrafficInterval)
        clearInterval(this.ipInterval)
        clearInterval(this.portInterval)
      }
    },
    lang: {
      handler (value) {
        setTimeout(() => {
          if (this.$refs.tenG) {
            this.$refs.tenG.$options.propsData.extend.xAxis.name = this.$t('overview.portNo')
          }
          if (this.$refs.oneG) {
            this.$refs.oneG.$options.propsData.extend.xAxis.name = this.$t('overview.portNo')
          }
          this.$forceUpdate()
        }, 200)
      },
      immediate: true
    },
    sensorStatus: {
      handler (value) {
        let tempData = []
        this.fanRpm = false
        if (value) {
          this.firstSysInfoLoad = false
          for (const key in value) {
            if (Object.hasOwnProperty.call(value, key)) {
              if (key === 'MaxFanRpm' || key === 'MinFanRpm') this.fanRpm = true
              const element = value[key]
              if (key.includes('Fan') && element > -1) {
                tempData.push({key: key, val: element})
                this.showFan = true
              }
            }
          }
        }
        this.fanData = (this.fanRpm) ? this.checkFanSpeed(tempData) : tempData
      },
      immediate: true
    },
    fwUpdating: {
      handler (value) {
        if (value) {
          clearInterval(this.systemInterval)
          clearInterval(this.portTrafficInterval)
          clearInterval(this.ipInterval)
          clearInterval(this.portInterval)
          this.systemInterval = null
          this.portTrafficInterval = null
          this.ipInterval = null
          this.portInterval = null
        }
      }
    }
  },
  created: async function () {
    window.addEventListener('resize', () => {
      if (this.$refs.oneG) {
        this.$refs.oneG.resize()
      }
    })
  },
  methods: {
    ...mapActions([
      'getPortStatus', 'getPortConfigure', 'getLagStatus', 'getVlan', 'getIP4Configure', 'getIP4Status', 'getOobIP4Status', 'getPortResource', 'getSystemSensorStatus', 'getPortResourcebyID', 'getFWcondition'
    ]),
    ...mapMutations(['openModal', 'closeModal']),
    getIcon: function (config) {
      let result = ''
      let data = config.data
      switch (config.type) {
        case 'enable':
          if (data) {
            result = 'icon-btn_close'
          } else {
            result = 'icon-tick'
          }
          break
        case 'connect':
          if (data) {
            result = 'icon-connect'
          } else {
            result = 'icon-disconnect'
          }
          break
      }
      return result
    },
    showInfo: function () {
      this.isShowLoading = true
      let user = this.currentUser
      if (user.authPassed === 1) {
        if (this.systemInterval === null) {
          this.systemInterval = setInterval(() => {
            this.getSysInfo()
          }, 10000)
        }
        if (this.portInterval === null) {
          this.portInterval = setInterval(() => {
            this.getPort()
          }, this.intervalTime)
        }
        this.getIpAddress()
        this.getPort()
        this.getPortTraffic()
      } else {
        this.$log.error('showInfo auth fail>>>>')
      }
    },
    trafficInterval: function () {
      let me = this
      this.getPortResource()
        .then(res => {
          if (res.data && res.data.error_code === 200) {
            let data = (res.data)
            this.trafficData = data
            if (me.systemHostInfo.Product.includes('M408') || me.systemHostInfo.Product.includes('M2108') || me.systemHostInfo.Product.includes('M5216') || me.systemHostInfo.Product.includes('M2106')) {
              this.getOnegTraffic()
            }
            this.getTengTraffic()
            this.isShowLoading = false
            this.oneTrafficLoad = false
          }
        })
    },
    getSysInfo: function () {
      let me = this
      this.getSystemSensorStatus()
        .then((result) => {
          if (result.data.error_code === 200) {
            // me.systemStatus = result.data.result
            // me.tempeture = me.systemStatus.SwitchTemp
            me.sysInfoLoad = false
          }
        }).catch((error) => {
          me.$log.error(error)
          if (me.systemInterval) {
            clearInterval(me.systemInterval)
          }
        })
      this.getIpAddress()
    },
    getPort: function () {
      let me = this
      this.axios.all([this.getPortStatus(), this.getPortConfigure()])
        .then(this.axios.spread(function (status, config) {
          let result = status.data.result
          result.forEach((element, idx) => {
            if (element.key === config.data.result[idx].key) {
              result[idx].val['Shutdown'] = config.data.result[idx].val.Shutdown
              result[idx].val['Combo'] = config.data.result[idx].val.Combo
              result[idx].val['MediaType'] = config.data.result[idx].val.MediaType
              me.portSpeed[idx] = element.val.Speed
            }
          })
          setTimeout(() => {
            result.forEach(item => {
              if (Number(item.key) <= me.portNumber) {
                let number = Number(item.key)
                let imgItem = (me.onlySFPlist.indexOf(number) < 0) ? document.getElementById('ethernet_' + number) : null
                let backgroundImg = (imgItem) ? me.$getElementsByClassName(imgItem, 'unconnected')[0] : null
                let connectImg = (imgItem) ? me.$getElementsByClassName(imgItem, 'symbol_enable')[0] : null
                let unconnectImg = (imgItem) ? me.$getElementsByClassName(imgItem, 'symbol_disable')[0] : null
                let sfpItem = (item.val.Combo || me.onlySFPlist.indexOf(number) > -1 || !me.systemHostInfo.Product.includes('M408')) ? document.getElementById('sfp_' + number) : null
                let sfpBackground = (sfpItem) ? me.$getElementsByClassName(sfpItem, 'unconnected')[0] : null
                let sfpConnect = (sfpItem) ? me.$getElementsByClassName(sfpItem, 'symbol_enable')[0] : null
                let sfpUnconnect = (sfpItem) ? me.$getElementsByClassName(sfpItem, 'symbol_disable')[0] : null
                let connect = (item.val.Shutdown) ? 'hidden' : 'visible'
                let unconnected = (item.val.Shutdown) ? 'visible' : 'hidden'
                let tooltipsElement = (imgItem) ? document.getElementById('tooltip_' + number) : null
                let sfptooltipsElement = (sfpItem) ? document.getElementById('tooltip_sfp_' + number) : null
                let speed = utility.bytesToSize(item.val.Speed, 1000).split(' ').join('')
                if (imgItem) {
                  connectImg.style.visibility = connect
                  unconnectImg.style.visibility = unconnected
                  tooltipsElement.lastElementChild.textContent = speed
                  imgItem.onmouseover = function () { tooltipsElement.style.visibility = 'hidden' }
                  imgItem.onmouseout = function () { tooltipsElement.style.visibility = 'hidden' }
                }
                if (sfpItem) {
                  sfpConnect.style.visibility = connect
                  sfpUnconnect.style.visibility = unconnected
                  sfptooltipsElement.lastElementChild.textContent = speed
                  sfpItem.onmouseover = function () { sfptooltipsElement.style.visibility = 'hidden' }
                  sfpItem.onmouseout = function () { sfptooltipsElement.style.visibility = 'hidden' }
                }
                if (!item.val.Link) {
                  if (imgItem) backgroundImg.style.fill = '#DBDDDD'
                  if (sfpItem) sfpBackground.style.fill = '#DBDDDD'
                  if (imgItem) imgItem.onmouseover = function () { tooltipsElement.style.visibility = 'hidden' }
                  if (sfpItem) sfpItem.onmouseover = function () { sfptooltipsElement.style.visibility = 'hidden' }
                } else {
                  if (item.val.Combo) {
                    if (item.val.MediaType === 'fiber') {
                      sfpBackground.style.fill = '#7ED321'
                      backgroundImg.style.fill = '#DBDDDD'
                      sfpItem.onmouseover = function () {
                        me.setTransform('sfp', number, speed)
                        sfptooltipsElement.style.visibility = 'visible'
                      }
                      imgItem.onmouseover = function () { tooltipsElement.style.visibility = 'hidden' }
                    } else if (item.val.MediaType === 'copper') {
                      sfpBackground.style.fill = '#DBDDDD'
                      backgroundImg.style.fill = '#7ED321'
                      sfpItem.onmouseover = function () { sfptooltipsElement.style.visibility = 'hidden' }
                      imgItem.onmouseover = function () {
                        me.setTransform('imgItem', number, speed)
                        tooltipsElement.style.visibility = 'visible'
                      }
                    } else {
                      sfpBackground.style.fill = '#DBDDDD'
                      backgroundImg.style.fill = '#DBDDDD'
                      imgItem.onmouseover = function () { tooltipsElement.style.visibility = 'hidden' }
                      sfpItem.onmouseover = function () { sfptooltipsElement.style.visibility = 'hidden' }
                    }
                  } else if (me.onlySFPlist.indexOf(number) > -1) {
                    sfpBackground.style.fill = '#7ED321'
                    sfpItem.onmouseover = function () {
                      me.setTransform('sfp', number, speed)
                      sfptooltipsElement.style.visibility = 'visible'
                    }
                  } else {
                    backgroundImg.style.fill = '#7ED321'
                    imgItem.onmouseover = function () {
                      tooltipsElement.style.visibility = 'visible'
                      me.setTransform('imgItem', number, speed)
                    }
                  }
                }
              }
            })
            me.portStatusLoad = false
            me.$forceUpdate()
          }, 200)
        }))
    },
    getPortTraffic: function () {
      if (this.portTrafficInterval === null) {
        this.portTrafficInterval = setInterval(() => {
          this.trafficInterval()
        }, this.intervalTime)
      }
      this.trafficInterval()
    },
    getIpAddress: function () {
      this.getIP4Configure()
        .then((res) => {
          if (res.data && res.data.error_code === 200 && res.data.result) {
            let data = res.data.result
            data.forEach(element => {
              if (element.key === '1') {
                if (element.val.enableInterface) {
                  if (element.val.enableDhcpClient) {
                    this.getInBandIpAddress()
                  } else {
                    this.ipAddress = element.val.ipv4Address
                  }
                } else {
                  this.getOutBandIpAddress()
                }
              }
            })
          }
        })
    },
    getInBandIpAddress: function () {
      this.getIP4Status()
        .then((res) => {
          if (res.data && res.data.error_code === 200) {
            let data = res.data
            if (data.result) {
              data.result.forEach(element => {
                if (element.key[0] === '1') {
                  this.ipAddress = element.key[1]
                }
              })
            }
          }
        })
    },
    getOutBandIpAddress: function () {
      this.getOobIP4Status()
        .then(res => {
          if (res.data && res.data.error_code === 200) {
            let data = res.data.result
            data.forEach(element => {
              if (element.key === '1') {
                this.ipAddress = element.val.ipv4Address
              }
            })
          }
        })
    },
    getOnegTraffic: function () {
      let me = this
      let data = me.trafficData
      let temp = []
      let sum = {'current': 0, 'total': 0}
      let portnumb = (me.systemHostInfo.Product.includes('M5216') ? 17 : 9)
      if (me.systemHostInfo.Product.includes('M2106')) portnumb = 7
      data.result.forEach((element, index) => {
        let number = parseInt(element.key)
        if (number < portnumb) {
          let total = element.val.RxOctets + element.val.TxOctets // 該port總和 (bytes)
          let current = Math.round(total / (me.intervalTime / 1000)) * 8 // bits per second
          if (me.preData.second && me.preData.second[number - 1]) {
            let traffic = null
            let now
            if (me.preData.second[number - 1].Traffic > current) {
              now = Math.abs(me.preData.second[number - 1].Traffic - me.preData.first[number - 1].Traffic)
            } else {
              now = Math.abs(current - me.preData.second[number - 1].Traffic)
            }
            now = utility.bytesToMGb(now, true)
            if (now[0] > me.portSpeed[number - 1] / 1000 * 1024) now[0] = me.portSpeed[number - 1] / 1000 * 1024
            traffic = (current === 0) ? '0' : (now[0])
            temp[index] = {
              'portNum': number,
              'Traffic': traffic
            }
          } else {
            temp.push({
              'portNum': number,
              'Traffic': '0'
            })
          }
          me.preData.first[number - 1] = me.preData.second[number - 1]
          me.preData.second[number - 1] = {
            'portNum': number,
            'Traffic': current
          }
          sum.current = sum.current + Number(temp[index].Traffic)
          // sum.total = sum.total + total
        }
      })
      if (sum.current !== 0) {
        sum.current = Number(sum.current.toFixed(2))
      }
      // sum.total = utility.bytesToMGb(sum.total)
      // sum.total = sum.total[0] + ' ' + (sum.total[1] || 'M') + 'B'
      me.trafficInfo.one = sum
      me.chartData.rows = temp
      me.oneTrafficLoad = false
    },
    getTengTraffic: function () {
      let me = this
      let data = me.trafficData
      let tenTemp = []
      let sum = {'current': 0, 'total': 0}
      let minNumber = (me.systemHostInfo.Product.includes('M408') || me.systemHostInfo.Product.includes('M2108')) ? 8 : 0
      if (me.systemHostInfo.Product.includes('M2106')) minNumber = 6
      if (me.systemHostInfo.Product.includes('M5216')) minNumber = 16
      data.result.forEach((element, index) => {
        let number = parseInt(element.key)
        if (number > minNumber && number <= me.portNumber) {
          let total = element.val.RxOctets + element.val.TxOctets // 該port總和 (bytes)
          let current = Math.round(total / (me.intervalTime / 1000)) * 8 // bits per second
          if (me.preData.second && me.preData.second[number - 1]) {
            let traffic = null
            let now
            if (me.preData.first[number - 1] && me.preData.second[number - 1].Traffic > current) {
              now = Math.abs(me.preData.second[number - 1].Traffic - me.preData.first[number - 1].Traffic)
            } else {
              now = Math.abs(current - me.preData.second[number - 1].Traffic)
            }
            now = utility.bytesToMGb(now, true)
            if (now[0] > me.portSpeed[number - 1] / 1000 * 1024) now[0] = me.portSpeed[number - 1] / 1000 * 1024
            traffic = (current === 0) ? '0' : (now[0])
            tenTemp[index - minNumber] = {
              'portNum': number,
              'Traffic': traffic
            }
          } else {
            tenTemp.push({
              'portNum': number,
              'Traffic': '0'
            })
          }
          me.preData.first[number - 1] = me.preData.second[number - 1]
          me.preData.second[number - 1] = {
            'portNum': number,
            'Traffic': current
          }
          sum.current = sum.current + Number(tenTemp[index - minNumber].Traffic)
          // sum.total = sum.total + total
        }
      })
      // let isGb = ' Mbps'
      // if (sum.current > 1024) {
      //   sum.current = Math.round(((sum.current / 1024) * 100) / 100)
      //   isGb = ' Gbps'
      // }
      if (sum.current !== 0) {
        sum.current = Number(sum.current.toFixed(2))
      }
      // sum.current += ' Mbps'
      // sum.total = utility.bytesToMGb(sum.total)
      // sum.total = sum.total[0] + ' ' + (sum.total[1] || 'M') + 'B'
      me.trafficInfo.ten = sum
      me.tenGchartData.rows = tenTemp
      me.tenTrafficLoad = false
    },
    yLabelFormatter: function (value, index) {
      let result = parseFloat(value)
      result = result.toFixed(1)
      return result
    },
    chartTooltipFormatter: function (params) {
      let value = (parseFloat(params[0].value) === 0) ? 0 : params[0].value
      return this.$t('overview.portNo') + ' ' + params[0].axisValueLabel + '<br/>' + value + ' ' + this.$t('mbps')
    },
    oneyAxisFormat: function (params) {
      if (parseFloat(this.trafficInfo.one.current) === 0) {
        if (params === 1 || params === 0) {
          return params
        }
      } else {
        return params
      }
    },
    tenyAxisFormat: function (params) {
      if (parseFloat(this.trafficInfo.ten.current) === 0) {
        if (params === 1 || params === 0) {
          return params
        }
      } else {
        return params
      }
    },
    onRefresh: function (type) {
      if (type === 'sysinfo') {
        this.sysInfoLoad = true
        this.getSysInfo()
      } else if (type === 'portstatus') {
        this.portStatusLoad = true
        this.getPort()
      } else if (type === 'oneG') {
        this.oneTrafficLoad = true
        if (this.portTrafficInterval) {
          clearInterval(this.portTrafficInterval)
          this.portTrafficInterval = null
          this.preData.second.forEach((element) => {
            let number = parseInt(element.key)
            if (number < 9) {
              this.preData.first[number - 1].Traffic = '0'
              this.preData.second[number - 1].Traffic = '0'
            }
          })
          this.chartData.rows.forEach((element, index) => {
            if (index < 9) {
              this.chartData.rows[index].Traffic = '0'
            }
          })
          this.trafficInfo.one = {'total': '0 GB', 'current': 0}
          setTimeout(() => {
            this.oneTrafficLoad = false
            this.$forceUpdate()
          }, 1000)
          setTimeout(() => {
            this.getPortTraffic()
          }, 2000)
        }
      } else if (type === 'twentyG5') {
        this.oneTrafficLoad = true
        if (this.portTrafficInterval) {
          clearInterval(this.portTrafficInterval)
          this.portTrafficInterval = null
          this.preData.second.forEach((element) => {
            let number = parseInt(element.key)
            if (number < 17) {
              this.preData.first[number - 1].Traffic = '0'
              this.preData.second[number - 1].Traffic = '0'
            }
          })
          this.chartData.rows.forEach((element, index) => {
            if (index < 17) {
              this.chartData.rows[index].Traffic = '0'
            }
          })
          this.trafficInfo.one = {'total': '0 GB', 'current': 0}
          setTimeout(() => {
            this.oneTrafficLoad = false
            this.$forceUpdate()
          }, 1000)
          setTimeout(() => {
            this.getPortTraffic()
          }, 2000)
        }
      } else {
        let minNumber = (this.systemHostInfo.Product.includes('M408') || this.systemHostInfo.Product.includes('M2108')) ? 8 : 0
        if (this.systemHostInfo.Product.includes('M2106')) minNumber = 6
        if (this.systemHostInfo.Product.includes('M5216')) minNumber = 16
        this.tenTrafficLoad = true
        if (this.portTrafficInterval) {
          clearInterval(this.portTrafficInterval)
          this.portTrafficInterval = null
          this.preData.second.forEach((element) => {
            let number = parseInt(element.key)
            if (number > minNumber) {
              this.preData.first[number - 1].Traffic = '0'
              this.preData.second[number - 1].Traffic = '0'
            }
          })
          this.tenGchartData.rows.forEach((element, index) => {
            this.tenGchartData.rows[index].Traffic = '0'
          })
          this.trafficInfo.ten = {'total': '0 GB', 'current': 0}
          setTimeout(() => {
            this.tenTrafficLoad = false
            this.$forceUpdate()
          }, 1000)
          setTimeout(() => {
            this.getPortTraffic()
          }, 2000)
        }
      }
    },
    onActiveClick: function () {
      this.$router.push({
        name: 'sysinformation'
      })
      this.$store.commit('updateMenu', this.menuList['SYSMANAGEMENT'].submenu['SYSTEMINFO'])
      setTimeout(() => {
        this.$router.push({
          name: 'sysinformation'
        })
        this.$store.commit('updateSubMenu', this.menuList['SYSMANAGEMENT'].submenu['SYSTEMINFO'].submenu['sysinformation'])
      }, 100)
    },
    getFanTitle: function (data, idx) {
      let title = ''
      if (this.fanData.length > 1) {
        title = this.$t('overview.multifanSpeed', idx + 1)
      } else {
        title = this.$t('overview.fanSpeed', null)
      }
      return title
    },
    checkFanSpeed: function (data) {
      let max = 0
      let min = 0
      let speed = []
      let result = true
      data.forEach(element => {
        if (element.key === 'MaxFanRpm') max = element.val
        if (element.key === 'MinFanRpm') min = element.val
        if (element.key.includes('Speed')) speed.push({ val: element.val })
      })
      speed.forEach(element => {
        if (element.val > max || element.val < min) result = false
      })
      return (result) ? speed : this.fanData
    },
    getTempMsg (data) {
      if (data && data.showTemp) return data.SwitchTemp + '°C'
      return this.tempMsg
    },
    setTransform (type, id, speed) {
      let tips = (type === 'sfp') ? 'tooltip_sfp_' : 'tooltip_'
      if (document.getElementById(tips + id).firstElementChild.getBoundingClientRect().width < 40) {
        let d = document.getElementById(tips + id).firstElementChild.getAttribute('d')
        d = d.split(/(?=[MH])/)
        d = d[0].substring(1)
        d = d.split(' ')
        let txt = document.getElementById(tips + id).lastElementChild
        let x = parseFloat(d[0]) - 15
        let y = parseFloat(d[1]) + 7
        switch (speed) {
          case '10M':
          case '10G':
          case '2.5G':
            break
          case '100M':
            x = x - 2
            break
          case '1G':
          case '5G':
            x = x + 2
            break
        }
        txt.removeAttribute('transform')
        txt.setAttribute('x', x)
        txt.setAttribute('y', y)
      } else {
        let d = document.getElementById(tips + id).firstElementChild.getAttribute('d')
        d = d.split(/(?=[MH])/)
        d = d[0].substring(1)
        d = d.split(' ')
        let txt = document.getElementById(tips + id).lastElementChild
        let x = parseFloat(d[0]) - 19
        let y = parseFloat(d[1]) + 9
        switch (speed) {
          case '10M':
          case '10G':
            break
          case '100M':
            x = x - 2
            break
          case '1G':
          case '5G':
            x = x + 2
            break
          case '2.5G':
            x = x - 1
            break
        }
        txt.removeAttribute('transform')
        txt.setAttribute('x', x)
        txt.setAttribute('y', y)
      }
    }
  },
  computed: {
    ...mapState({
      lang: state => state.app.lang,
      portNumber: state => state.module.portNum,
      fwinfo: state => state.module.fwinfo,
      sysBoard: state => state.module.sysBoard,
      systemHostInfo: state => state.module.systemHostInfo,
      showInfoTips: state => state.app.showInfoTips,
      showFullLoading: state => state.module.showFullLoading,
      currentUser: state => state.module.currentUser,
      sensorStatus: state => state.module.sensorStatus,
      intervalTime: state => state.app.intervalTime,
      fwUpdating: state => state.module.fwUpdating
    }),
    displayDateTime: function () {
      let displayTime = ''
      if (this.systemTime) {
        displayTime = moment(this.systemTime.SystemCurTime).format(this.systemTime.SystemCurTimeFormat)
      } else {
        displayTime = 'unknow'
      }
      return displayTime
    },
    ipAddressMag: function () {
      let result = this.$t('overview.loading')
      if (this.ipAddress) {
        result = this.ipAddress
      }
      return result
    },
    tempMsg: function () {
      let temperature = (this.sensorStatus) ? this.sensorStatus.SwitchTemp : null
      let tempMax = (this.sensorStatus) ? this.sensorStatus.MaxSwitchTemp : 1000
      let tempMin = (this.sensorStatus) ? this.sensorStatus.MinSwitchTemp : null
      let strings = '--'
      if (temperature) {
        if (temperature > tempMax) {
          strings = this.$t('overview.abnormal')
        } else if (temperature < tempMin) {
          strings = this.$t('overview.abnormal')
        } else {
          strings = this.$t('overview.normal')
        }
      }
      return strings
    },
    maxTemp: function () {
      let result = 1000
      if (this.sensorStatus) {
        result = this.sensorStatus.MaxSwitchTemp
        return result
      }
      return result
    },
    minTemp: function () {
      let result = -1000
      if (this.sensorStatus && this.sensorStatus.MinSwitchTemp) {
        result = this.sensorStatus.MinSwitchTemp
        return result
      }
      return result
    },
    activePower: function () {
      let result = '--'
      this.sensorStatus.PowerInfo.forEach((item, index) => {
        if (item.PowerSource === 'Active') {
          result = this.$t('overview.power', index + 1)
        }
      })
      return result
    },
    onlySFPlist: function () {
      return config.system.sfpPort[this.systemHostInfo.Product]
    },
    getPortTrafficName: function () {
      let result = (this.systemHostInfo.Product.includes('M2108') || this.systemHostInfo.Product.includes('M2106')) ? this.$t('overview.twoG5traffic') : this.$t('overview.oneGtraffic')
      if (this.systemHostInfo.Product.includes('M5216')) result = this.$t('overview.twentyG5traffic')
      return result
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../assets/scss/variables.scss';
@import '../assets/scss/common.scss';

.dashboard {
  color: #000000;
  position: relative;
  .content-body {
    overflow-y: auto;
    background: #f2f2f2;
  }
  .col-header {
    user-select: none;
    margin-bottom: 10px;
    font-size: 16px;
    line-height: 16px;
    font-weight: bold;
  }
  .row {
    margin-left: initial;
    margin-right: initial;
    >.content {
      background: #ffffff;
      border-radius: 4px;
      padding: 10px 20px;
      height: 100%;
      position: relative;
      >.col-body {
        line-height: 14px;
      }
      >.icon-refresh {
        position: absolute;
        cursor: pointer;
        right: 10px;
        top: 10px;
        &::before:active {
          color: #6D6D6D;
        }
        &:hover {
          color: #BABABA;
        }
      }
    }
  }
  .top_layer {
    top: 0;
    margin-bottom: 10px;
    display: -webkit-flex;
    display: flex;
    height: 190px;
    background: #f2f2f2;
    >.row.left {
      margin-right: 10px;
      width: 600px;
      flex: none;
      .col-body {
        margin-top: 5px;
        >.title {
          width: auto;
          display: inline-block;
        }
      }
      .legend {
        position: absolute;
        bottom: 0px;
        right: 0px;
        display: flex;
        justify-content: flex-end;
        flex-wrap: wrap-reverse;
        align-items: center;
        padding-right: 10px;
        padding-bottom: 5px;
        .link, .nolink, .loop, .tenG-link {
          &::before {
            content: "";
            width: 14px;
            height: 14px;
            margin: 0px 5px 1px 10px;
            margin-bottom: 1px;
            width: 7px;
            height: 7px;
            border-radius: 50%;
            display: inline-block;
          }
        }
        .link::before {
          background-color: #7ED321;
        }
        .nolink::before {
          background-color: #DBDDDD;
        }
        .loop::before {
          background-color: #F54848;
        }
        .tenG-link::before {
          background-color: #32CCFF;
        }
        .enable-status {
          display: inline-block;
        }
        .icon-tick, .icon-btn_close, .link, .nolink {
          display: inline-block;
      }
      }
    }

    >.row.right {
      flex: 1;
      >.content {
      .scrollbar-body {
        height: calc(100% - 17px);
      }
        .col-body {
          .table-row {
            line-height: 14px;
            margin-bottom: 10px;
            .title {
              display: inline-block;
              font-family: 'Roboto-M', 'Microsoft JhengHei' !important;
            }
            .value {
              display: inline-block;
              font-family: 'Roboto-R', 'Microsoft JhengHei' !important;
              &.active-power {
                text-decoration: underline;
                &:hover {
                  cursor: pointer;
                }
              }
            }
          }
        }
      }

    }
  }
  .bottom_layer {
    height: calc(100% - 200px);
    min-height: 300px;
    display: -webkit-flex;
    display: flex;
    font-size: 14px;
    background: #f2f2f2;
    .ve-histogram {
      margin-top: 25px;
    }
    .traffic-info {
      margin-bottom: 5px;
    }
    >.row.left {
      max-width: 60%;
      .content {
        .col-body {
          position: relative;
          margin-top: 15px;
          .title {
            font-family: 'Roboto-M';
            margin-bottom: 5px;
          }
        }
      }
    }
    .row.right {
      margin-left: 10px;
      max-width: 40%;
      .col-body {
        margin-top: 15px;
      }
    }
    .row {
      width: 100%;
    }
  }
  .device-img {
    &.Link {
      svg {
        background: #7ED321;
        padding: 2px;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Dashboard.vue